/* eslint-env browser */
var modal = require('../../../modal/modal-static')

var spinner;

// Given the spinner hidden state has changed
// When the spinner is hidden
// Then reset it's textContent
// And ensure it's appended to the document.body

// Given the spinner hidden state has changed
// When the spinner is visible
// Then close any modals

var showspinner = function (hideText) {
  hideText && spinner.lastElementChild.textContent
  spinner.hidden = false
}

var reset = function () {
  spinner.lastElementChild.textContent = spinner.dataset.text
  spinner.parentNode !== document.body &&
    document.body.appendChild(spinner)
}

var observer = new MutationObserver(function () {
  spinner.hidden ? reset() : modal.destroy()
})

var set = function() {
  spinner = document.getElementById('photo-upload-spinner')
  if (spinner) {
    spinner.parentNode !== document.body &&
    document.body.appendChild(spinner)
    observer.observe(spinner, {
      attributes: true,
      attributeFilter: ['hidden']
    })
    spinner.hidden = true
  }
}

// Given a viewport has been loaded
// When the spinner is available in the DOM
// Then observe changes in its hidden state

document.addEventListener('DOMContentLoaded', set)

module.exports = {
  spinner: spinner,
  showspinner: showspinner,
  setSpinner: set
}
